<template>
    <v-container id="container" grid-list-lg>
        <v-layout align-center row wrap>
            <v-flex v-for="card in homeCards" sm12 md3>
                <v-card class="elevation-12" :to="card.link" :href="card.link">
                    <v-img :src="card.imageLink" height="500px">
                        <v-container fill-height fluid>
                            <v-layout align-center>
                                <v-flex class="">
                                    <p class="display-2 font-weight-bold white--text text-center">{{card.title}}</p>
                                    <p class="title font-weight-bold white--text text-center mb-0">{{card.subtitle}}</p>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-img>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md3>
                <v-card class="elevation-12" href="http://www.limokorea.co.kr/login.do">
                    <v-img src="../../assets/mainpage/chauffeur.jpg" height="500px">
                        <v-container fill-height fluid>
                            <v-layout align-center>
                                <v-flex class="">
                                    <p class="display-2 font-weight-bold white--text text-center">기사포함대여</p>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-img>
                </v-card>
            </v-flex>
            <v-row>
                <v-spacer></v-spacer>
                <v-flex v-for="btn in setApptBtns" xs12 sm5 lg3>
                    <v-card class="pa-6 elevation-12" @click="sendToNewLink(btn.link)">
                        <div class="d-flex flex-no-wrap justify-space-between">
                            <div>
                                <v-card-title class="headline font-weight-bold teal--text">{{btn.title}}</v-card-title>
                                <v-card-subtitle>{{btn.subtitle}}</v-card-subtitle>
                            </div>
                            <v-avatar class="my-auto" size="85" tile>
                                <v-img :src="btn.logo">
                                </v-img>
                            </v-avatar>
                        </div>
                    </v-card>
                </v-flex>
                <v-spacer></v-spacer>
            </v-row>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: "HomeMainCards",
  data: () => ({
      homeCards: [
          {
              title: '신차 장기',
              subtitle: '합리적 신차구매',
              link: '/newcar',
              imageLink: require('../../assets/mainpage/newcar.jpg')
          },
          {
              title: '중고차 장기',
              subtitle: '월간대여',
              link: '/usedcar',
              imageLink: require('../../assets/mainpage/usedcar.jpg')
          },
          {
              title: '단기대여',
              subtitle: '저렴한가격',
              link: '/shortterm',
              imageLink: require('../../assets/mainpage/shortterm.jpg')
          }
      ],
      setApptBtns: [
          {
              title: '웹포털',
              subtitle: '인터넷 브라우저로 예약하거나',
              link: 'http://www.limokorea.co.kr/login.do',
              logo: require('../../assets/logo2.png')
          },
          {
              title: '불러 앱',
              subtitle: '모바일앱으로 간편하게 예약!',
              link: 'http://www.limokorea.co.kr/login.do',
              logo: require('../../assets/bullerlogo.webp')
          }
      ]
  })
};
</script>

<style scoped>
p {
  text-shadow: 2px 2px 8px black;
}
</style>
